<template>
  <div v-if="showThemeToggle" class="toggle-mode" :class="{toggled: this.themeMode === 'dark' }" @click="toggleThemeMode()">
    <div class="toggle-moon">🌛</div>
    <div class="toggle-sun">☀️</div>
    <div class="toggle-thumb"></div>
  </div>
</template>

<script>
import theme from '@/mixins/theme'

export default {
  mixins: [theme]
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
.toggle-mode {
  background-color: #1a1a1a;
  border-radius: 30px;
  cursor: pointer;
  display: flex;
  height: 24px;
  position: relative;
  user-select: none;
  width: 50px;
  margin-left: 1rem;
}

.toggle-sun,
.toggle-moon {
  align-items: center;
  display: flex;
  font-size: 12px;
  padding: 0 4px;
  width: 50%;
}

.toggle-moon {
  justify-content: flex-end;
}

.toggle-thumb {
  background-color: #fff;
  border-radius: 50%;
  height: 20px;
  left: 2px;
  position: absolute;
  top: 2px;
  transition: transform .5s cubic-bezier(.23,1,.32,1);
  width: 20px;
}

.toggle-mode.toggled .toggle-thumb {
  transform: translateX(26px);
}
</style>
